/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmi_height_ftin = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Height (ft / in)`)
};

const es_bmi_height_ftin = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altura (pies/pulgadas)`)
};

const de_bmi_height_ftin = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Größe (ft / in)`)
};

const nl_bmi_height_ftin = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lengte (ft / in)`)
};

const fr_bmi_height_ftin = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille (pi / po)`)
};

const it_bmi_height_ftin = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altezza (ft / in)`)
};

const pt_br2_bmi_height_ftin = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altura (pés / polegadas)`)
};

const pt_bmi_height_ftin = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altura (pés / pol)`)
};

const ja_bmi_height_ftin = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`身長 (フィート / インチ)`)
};

const zh_bmi_height_ftin = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`身高（英尺 / 英寸）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmi_height_ftin = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmi_height_ftin(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmi_height_ftin", locale)
	if (locale === "en") return en_bmi_height_ftin(inputs)
	if (locale === "es") return es_bmi_height_ftin(inputs)
	if (locale === "de") return de_bmi_height_ftin(inputs)
	if (locale === "nl") return nl_bmi_height_ftin(inputs)
	if (locale === "fr") return fr_bmi_height_ftin(inputs)
	if (locale === "it") return it_bmi_height_ftin(inputs)
	if (locale === "pt-BR") return pt_br2_bmi_height_ftin(inputs)
	if (locale === "pt") return pt_bmi_height_ftin(inputs)
	if (locale === "ja") return ja_bmi_height_ftin(inputs)
	return zh_bmi_height_ftin(inputs)
};